import { useImmutableQuery, useQuery } from "@/api/swr/useQuery";
import { statusSchema } from "@/schema/Status";
import { z } from "zod";

const statusesSchema = z.array(statusSchema);

type Config = Parameters<typeof useQuery<typeof statusesSchema>>[2];

export function useGetStatuses(config: Config) {
  return useImmutableQuery(statusesSchema, "/console/statuses", config);
}
